import {
  deliveryFailedStates,
  deliverySuccessStates,
  miscStates,
  pickupFailedStates,
  pickupSuccessStates,
} from "./consignmentStates.js";
import {imageBaseUrl} from "./getData.js";
import {initMap} from "./initMap.js";
import {initMapOnlyMap} from "./initMapOnlyMap.js";
import {handleModalLogic} from "./shipmentModal.js";
import {
  identifierClasses,
  identifierIds,
  orderStates,
  orderStatesReverse,
  stateClasses,
} from "./statesAndIdentifiers.js";
import {
  comingSoonPageTemplate,
  setPageTemplate,
  currentAttemptStepTemplate,
  shipmentsModalTemplate,
} from "./templates.js";
import {
  checkDeliveryStatus,
  checkPickupStatus,
  checkReturnStatus,
  checkRiderStatus,
  deliveryFailedDom,
  getAllStateClassesExcept,
  getObjectKeys,
  getTitle,
  markDeliveryOngoing,
  pickupFailedDom,
  returnFailedDom,
  HyderateAllUpdatesSection,
} from "./utils.js";

const setEventDateTime = (identifier, dateTime) => {
  const dateNode = $(identifier)?.find(identifierClasses.DATE);
  dateNode.text(dateTime);
};

export const setOrderFailedDate = (identifier, dateTime) => {
  $(identifier)?.text(dateTime);
};

export const setEventTitle = (identifier, title) => {
  const titleNode = $(identifier).find(identifierClasses.TITLE);
  titleNode.text(title);
};

export const setEventReasoning = (identifier, title) => {
  const titleNode = $(identifier).find(identifierClasses.REASONING);
  titleNode.text(title);
};

const setInnerHtml = (selector, html) => {
  $(selector)?.html(html);
};

export const setStepState = (identifier, stateClass) => {
  $(identifier)
    ?.addClass(stateClass)
    .removeClass(getAllStateClassesExcept(stateClass));
};

export const setImage = (identifier1, identifier2) => {
  $(identifier1)?.css("display", "none");

  $(identifier2)?.css("display", "initial");
};

export const populateShipments = (shipmentList, orderId) => {
  if (!shipmentList || !shipmentList.length) return;

  $(document).ready(function () {
    const shipmentsContainer = $(".shipments-text-container");
    const shipmentsContainerMweb = $(".shipments-text-container-mweb");
    const shipmentsText = $("#shipments-id-text");
    const shipmentsTextMweb = $("#shipments-id-text-mweb");

    const shipmentCtaClickHander = () => {
      $(".modal-wrapper").addClass("visible");
      $("body").css("overflow", "hidden");
      const template = shipmentsModalTemplate();
      setInnerHtml(identifierIds.SHIPMENTS_MODAL, template);
      handleModalLogic(shipmentList, orderId);
    };
    if (
      shipmentList &&
      shipmentList?.length == 1 &&
      orderId &&
      shipmentList[0] == orderId
    ) {
      shipmentsContainer.css("display", "none");
      shipmentsContainerMweb.css("display", "none");
      return;
    } else if (shipmentList && shipmentList?.length >= 1) {
      const shipmentsLength = shipmentList.length;
      shipmentsText.text(`${shipmentsLength} Shipments`);
      shipmentsTextMweb.text(`${shipmentsLength} Shipments`);
      shipmentsContainer?.click(function () {
        shipmentCtaClickHander();
      });
      shipmentsContainerMweb?.click(function () {
        shipmentCtaClickHander();
      });
    }
  });
};

const isEmpty = (obj) => {
  return Object.keys(obj).length == 0;
};

const InitiateMap = (
  markers,
  isReverseOrder,
  attemptCount,
  eventArray,
  eventTypes,
) => {
  const eventArrayFlat = [];

  let tempMarker = [
    ...(!isNaN(markers?.riderLoc?.position?.lat) ? [markers?.riderLoc] : []),
    ...(!isNaN(markers?.dropLoc?.position?.lat) ? [markers?.dropLoc] : []),
  ];

  let dropLoc = true;
  if (isNaN(markers?.dropLoc?.position?.lat)) dropLoc = false;

  for (let key in eventArray) {
    eventArray[key].forEach((event) => {
      eventArrayFlat.push(event);
    });
  }

  const sortedEvents = eventArrayFlat?.sort((a, b) => {
    const timestampA = new Date(a.timestamp).getTime();
    const timestampB = new Date(b.timestamp).getTime();
    return timestampA - timestampB;
  });

  const filteredSortedEvents = sortedEvents.filter((obj) => {
    return !isEmpty(obj);
  });

  const lastEvent = filteredSortedEvents[filteredSortedEvents.length - 1];

  const ERCode =
    lastEvent?.eventCode +
    (lastEvent?.reasonCode ? `-${lastEvent?.reasonCode}` : "");
  // const ERCode = lastEvent?.eventCode + "-" + lastEvent?.reasonCode;

  const successStates = [
    ...deliverySuccessStates,
    ...(isReverseOrder ? pickupSuccessStates : []),
    ...miscStates.SUCCESS,
  ];

  const failureStates = [
    ...deliveryFailedStates,
    ...pickupFailedStates,
    ...miscStates.FAILURE,
  ];

  if (successStates.includes(ERCode)) {
    if (dropLoc) {
      tempMarker = [
        {...markers.dropLoc, icon: imageBaseUrl + "map-success.png"},
      ];
    }
  }

  if (failureStates.includes(ERCode)) {
    if (dropLoc) {
      tempMarker = [
        {...markers.dropLoc, icon: imageBaseUrl + "map-failed.png"},
      ];
    }
  }

  if (ERCode.includes("E-021") && attemptCount < 3) {
    if (isReverseOrder)
      setInnerHtml(
        identifierIds.ORDER_STATE,
        "Your return order will be rescheduled",
      );
    else
      setInnerHtml(identifierIds.ORDER_STATE, "Your order will be rescheduled");
  }

  const stepState = checkDeliveryStatus(ERCode);

  if (stepState == stateClasses.FAILED && attemptCount >= 3) {
    if (isReverseOrder) {
      setInnerHtml(identifierIds.ORDER_STATE, "Your return order failed");
    } else setInnerHtml(identifierIds.ORDER_STATE, "Order not delivered");
  }

  initMap([...tempMarker]);
};

export const setMap = (riderLoc, pickupLoc, dropLoc) => {
  initMap([pickupLoc, pickupLoc, dropLoc]);
};

export const setOrderId = ({
  orderID,
  orderState,
  isReverseOrder,
  attemptCount,
  isRecentPickupFailed,
  isRecentDropFailed,
}) => {
  const orderIdText = `Order ID #${orderID}`;
  let orderStateText = isReverseOrder
    ? orderStatesReverse[orderState]
    : orderStates[orderState];
  if (orderState == "inProgress:scheduled" && attemptCount >= 1)
    orderStateText = "Your order will be re-attempted";
  if (isRecentPickupFailed)
    orderStateText = "Your order could not be picked up";

  // if (isRecentDropFailed) orderStateText = "Your order will be re-attempted";
  if (isRecentPickupFailed && isReverseOrder)
    orderStateText = "Your return order could not be picked up";
  // if (isRecentDropFailed) setImage("#order-image1", "#order-image3");
  if (isRecentPickupFailed) setImage("#order-image1", "#order-image3");
  if (orderState == "inProgress:active" && isReverseOrder)
    setImage("#order-image1", "#order-image2");
  if (isRecentDropFailed && isReverseOrder && attemptCount < 3)
    setImage("#order-image2", "#order-image1");
  if (isRecentDropFailed && isReverseOrder && attemptCount == 3)
    setImage("#order-image2", "#order-image3");

  if (
    orderState == "executed:delivered" ||
    orderState == "executed:success" ||
    orderState == "closed:success"
  )
    setImage("#order-image1", "#order-image2");
  if (
    orderState == "executed:undelivered" ||
    orderState == "executed:failed" ||
    orderState == "closed:failed"
  )
    setImage("#order-image1", "#order-image3");
  setInnerHtml(identifierIds.ORDER_ID, orderIdText);
  setInnerHtml(identifierIds.ORDER_STATE, orderStateText);
};

export const setRiderName = (riderName, isReverseOrder) => {
  $("#consignee-block")?.css("display", "block");
  $(".cards")?.css("border-bottom-left-radius", "0px");
  $(".cards")?.css("border-bottom-right-radius", "0px");
  let riderNameText = "";
  if (isReverseOrder) {
    riderNameText = riderName + " is on the way to pickup your order.";
  } else {
    riderNameText = riderName + " is on the way to deliver your order.";
  }
  setInnerHtml(identifierIds.CONSIGNEE_NAME, riderNameText);
};

export const setRiderNumber = ({countryCode, phoneNumber}) => {
  const code = countryCode;
  const number = phoneNumber;
  const viewportWidth = window.innerWidth;
  const phoneNumberText = code + number;
  const link = $("#tel");
  link.attr("href", "tel:" + phoneNumberText);
  $("#consignee-img1")?.css("display", "block");
  $(".telphone-number")?.css("display", "block");
  // if(viewportWidth>600){
  const showBtn = $("#consignee-img4");
  const message = $(".message-block");
  const copymessage = $(".message-text");
  const closeMessage = $(".message-close");
  showBtn?.css("display", "block");
  const copy = $("#consignee-img2");
  const hideBtn = $("#consignee-img3");
  setInnerHtml(".phone-number", "xxxxxxxxxx");

  const copyTooltip = $(".tooltip");

  showBtn.click(function () {
    hideBtn?.css("display", "block");
    copy?.css("display", "block");
    showBtn?.css("display", "none");
    setInnerHtml(".phone-number", number);
    copyTooltip?.css("display", "block");
  });

  $(document)
    .on("mouseenter", "#consignee-img2", function () {
      // Mouse enter: Apply styles
      $(".tooltip-text").css("display", "block");
    })
    .on("mouseleave", "#consignee-img2", function () {
      // Mouse leave: Remove styles
      $(".tooltip-text").css("display", "none");
    });
  function copyphoneNumber() {
    var tempInput = $("<input>");
    $("body").append(tempInput);
    // Set the value of the input to the phone number text
    tempInput.val(phoneNumberText).select();
    document.execCommand("copy");
    tempInput.remove();
    message?.css("display", "flex");
    setInnerHtml(copymessage, "Phone number copied successfully!");
    setTimeout(function () {
      message?.css("display", "none");
      // }
    }, 3000);
  }
  copy.click(copyphoneNumber);
  hideBtn?.click(function () {
    hideBtn?.css("display", "none");
    copy?.css("display", "none");
    showBtn?.css("display", "block");
    setInnerHtml(".phone-number", "xxxxxxxxxx");
    copyTooltip?.css("display", "none");
  });

  closeMessage.click(function () {
    message?.css("display", "none");
  });
  // }
};

export const setPage = (template) => {
  setInnerHtml(identifierIds.WRAPPER, template);
};

// export const setPageResponse = (response) => {
// 	if (!response?.data?.order?.clientOrderId) {
// 		setPage(`order not found`);
// 	}
// };
export const setExpectedDate = (epoch) => {
  const milliseconds = epoch * 1000;
  const dateObject = new Date(milliseconds);

  // Extract individual date and time components
  const year = dateObject.getFullYear();
  const month = dateObject.getMonth() + 1; // Months are zero-based, so add 1
  const day = dateObject.getDate();
  const hours = dateObject.getHours();
  const minutes = dateObject.getMinutes();
  const seconds = dateObject.getSeconds();

  // Format the date and time components
  const formattedDate = `${year}-${padNumber(month)}-${padNumber(day)}`;
  const formattedTime = `${padNumber(hours)}:${padNumber(minutes)}:${padNumber(
    seconds,
  )}`;

  // setInnerHtml(identifierIds.ESTIMATED_DATE, formattedDate);
  setInnerHtml(
    identifierIds.ESTIMATED_TIME,
    `Estimated delivery time ${formattedTime}`,
  );
};

function padNumber(number) {
  // Add leading zero if the number is less than 10
  return number < 10 ? "0" + number : number;
}

export const setStatusForCategories = (
  eventArray = [
    {
      eventCode: "",
      reasonCode: "",
      timestamp: null,
    },
  ],
) => {
  for (let event of eventArray) {
    const dateTime = new Date(event?.timestamp).toLocaleString();
    const ERCode = event.eventCode + "-" + event.reasonCode;
    const title = getTitle(ERCode);
    const category = checkCategory(ERCode);
    let identifier;
    let stepState;

    switch (category) {
      case "DELIVERY":
        identifier = identifierIds.DELIVERY;
        stepState = checkDeliveryStatus(ERCode);
        break;

      case "PICKUP":
        identifier = identifierIds.PICKUP;
        stepState = checkPickupStatus(ERCode);
        break;
    }

    setStepState(identifier, stepState);
    setEventDateTime(identifier, dateTime);
    setEventTitle(identifier, title);
  }
};

const isReversePickupFailedCurrent = (eventObject) => {
  const pickup = eventObject?.pickup[0];
  // const ERCode = pickup?.eventCode + "-" + pickup?.reasonCode;
  const ERCode =
    pickup?.eventCode + (pickup?.reasonCode ? `-${pickup?.reasonCode}` : "");
  const pickupState = checkPickupStatus(ERCode);
  if (pickupState == stateClasses?.FAILED) return true;
  else return false;
};

export const setConsigneeStates = (
  events,
  orderId,
  markers,
  isReverseOrder,
  attemptCount,
  state,
) => {
  const {
    prevFailedArrayNew,
    currentArrayNew,
    prevFailedArrayLogic,
    flatcurrentArrayLogic,
  } = events;

  const currentArrayNewTypes = getObjectKeys(flatcurrentArrayLogic[0] ?? {});

  let currentEventObject = Object.keys(flatcurrentArrayLogic[0] ?? {});

  const isReversePickupFailed = true;
  if (!currentEventObject.includes("pickup")) {
    flatcurrentArrayLogic[0] = {
      ...flatcurrentArrayLogic[0],
      pickup: [{}],
    };
  }

  if (
    (!isReverseOrder &&
      !currentEventObject.includes("delivery") &&
      !currentEventObject.includes("misc")) ||
    (isReverseOrder &&
      !currentEventObject.includes("return") &&
      !currentEventObject.includes("misc"))
  ) {
    flatcurrentArrayLogic[0] = {
      ...flatcurrentArrayLogic[0],
      ...(isReverseOrder
        ? isReversePickupFailedCurrent(flatcurrentArrayLogic[0])
          ? {}
          : {return: [{}]}
        : isReversePickupFailedCurrent(flatcurrentArrayLogic[0])
          ? {}
          : {delivery: [{}]}),
    };
  }

  if (
    !(currentArrayNewTypes?.length > 0) &&
    !(prevFailedArrayLogic?.length > 0)
  ) {
    const template = comingSoonPageTemplate(orderId, isReverseOrder);
    setPage(template);
    return;
  }

  const parent = document.querySelector(".failed-steps");

  prevFailedArrayLogic.forEach((prevFailedEventArray, index) => {
    const failedType =
      prevFailedEventArray?.delivery?.length > 0
        ? "delivery"
        : prevFailedEventArray?.return?.length > 0
          ? "return"
          : "pickup";

    const currentDom =
      failedType == "delivery"
        ? deliveryFailedDom(index, prevFailedEventArray, prevFailedArrayLogic)
        : failedType == "return"
          ? returnFailedDom(index, prevFailedEventArray, prevFailedArrayLogic)
          : pickupFailedDom(index, prevFailedEventArray, prevFailedArrayLogic);

    // const currentDom = ispickedUpFailed
    //   ? pickupFailedDom(index, prevFailedEventArray, prevFailedArrayLogic)
    //   : deliveryFailedDom(index, prevFailedEventArray, prevFailedArrayLogic);

    parent.appendChild(currentDom);

    const previousAttemptTypes = getObjectKeys(prevFailedEventArray);

    HyderateAllUpdatesSection(
      prevFailedEventArray,
      previousAttemptTypes,
      isReverseOrder,
      `.del-steps-${index}`,
      false,
      attemptCount,
      markers,
      state,
    );
  });

  HyderateAllUpdatesSection(
    flatcurrentArrayLogic[0],
    currentArrayNewTypes,
    isReverseOrder,
    `.current-steps`,
    true,
    attemptCount,
    markers,
    state,
  );

  InitiateMap(
    markers,
    isReverseOrder,
    attemptCount,
    flatcurrentArrayLogic[0],
    currentArrayNewTypes,
  );
};

// -------------------- OnlyMap

export const setConsigneeStatesOnlyMap = (
  events,
  orderId,
  markers,
  isReverseOrder,
  attemptCount,
  state,
) => {
  const {prevFailedArrayLogic, flatcurrentArrayLogic} = events;

  const currentArrayNewTypes = getObjectKeys(flatcurrentArrayLogic[0] ?? {});

  let currentEventObject = Object.keys(flatcurrentArrayLogic[0] ?? {});

  if (!currentEventObject.includes("pickup")) {
    flatcurrentArrayLogic[0] = {
      ...flatcurrentArrayLogic[0],
      pickup: [{}],
    };
  }

  if (
    (!isReverseOrder &&
      !currentEventObject.includes("delivery") &&
      !currentEventObject.includes("misc")) ||
    (isReverseOrder &&
      !currentEventObject.includes("return") &&
      !currentEventObject.includes("misc"))
  ) {
    flatcurrentArrayLogic[0] = {
      ...flatcurrentArrayLogic[0],
      ...(isReverseOrder
        ? isReversePickupFailedCurrent(flatcurrentArrayLogic[0])
          ? {}
          : {return: [{}]}
        : isReversePickupFailedCurrent(flatcurrentArrayLogic[0])
          ? {}
          : {delivery: [{}]}),
    };
  }

  if (
    !(currentArrayNewTypes?.length > 0) &&
    !(prevFailedArrayLogic?.length > 0)
  ) {
    const template = comingSoonPageTemplate(orderId, isReverseOrder);
    setPage(template);
    return;
  }

  // const parent = document.querySelector(".failed-steps");

  // prevFailedArrayLogic.forEach((prevFailedEventArray, index) => {
  //   const failedType =
  //     prevFailedEventArray?.delivery?.length > 0
  //       ? "delivery"
  //       : prevFailedEventArray?.return?.length > 0
  //         ? "return"
  //         : "pickup";

  //   const currentDom =
  //     failedType == "delivery"
  //       ? deliveryFailedDom(index, prevFailedEventArray, prevFailedArrayLogic)
  //       : failedType == "return"
  //         ? returnFailedDom(index, prevFailedEventArray, prevFailedArrayLogic)
  //         : pickupFailedDom(index, prevFailedEventArray, prevFailedArrayLogic);

  //   parent.appendChild(currentDom);

  //   const previousAttemptTypes = getObjectKeys(prevFailedEventArray);

  //   HyderateAllUpdatesSection(
  //     prevFailedEventArray,
  //     previousAttemptTypes,
  //     isReverseOrder,
  //     `.del-steps-${index}`,
  //     false,
  //     attemptCount,
  //     markers,
  //     state,
  //   );
  // });

  InitiateMapOnlyMap(
    markers,
    isReverseOrder,
    attemptCount,
    flatcurrentArrayLogic[0],
    currentArrayNewTypes,
  );
};

const InitiateMapOnlyMap = (
  markers,
  isReverseOrder,
  attemptCount,
  eventArray,
  eventTypes,
) => {
  const eventArrayFlat = [];

  let tempMarker = [
    ...(!isNaN(markers?.riderLoc?.position?.lat) ? [markers?.riderLoc] : []),
    ...(!isNaN(markers?.dropLoc?.position?.lat) ? [markers?.dropLoc] : []),
  ];

  let dropLoc = true;
  if (isNaN(markers?.dropLoc?.position?.lat)) dropLoc = false;

  for (let key in eventArray) {
    eventArray[key].forEach((event) => {
      eventArrayFlat.push(event);
    });
  }

  const sortedEvents = eventArrayFlat?.sort((a, b) => {
    const timestampA = new Date(a.timestamp).getTime();
    const timestampB = new Date(b.timestamp).getTime();
    return timestampA - timestampB;
  });

  const filteredSortedEvents = sortedEvents.filter((obj) => {
    return !isEmpty(obj);
  });

  const lastEvent = filteredSortedEvents[filteredSortedEvents.length - 1];

  const ERCode =
    lastEvent?.eventCode +
    (lastEvent?.reasonCode ? `-${lastEvent?.reasonCode}` : "");
  // const ERCode = lastEvent?.eventCode + "-" + lastEvent?.reasonCode;

  const successStates = [
    ...deliverySuccessStates,
    ...(isReverseOrder ? pickupSuccessStates : []),
    ...miscStates.SUCCESS,
  ];

  const failureStates = [
    ...deliveryFailedStates,
    ...pickupFailedStates,
    ...miscStates.FAILURE,
  ];

  if (successStates.includes(ERCode)) {
    if (dropLoc) {
      tempMarker = [
        {...markers.dropLoc, icon: imageBaseUrl + "map-success.png"},
      ];
    }
  }

  if (failureStates.includes(ERCode)) {
    if (dropLoc) {
      tempMarker = [
        {...markers.dropLoc, icon: imageBaseUrl + "map-failed.png"},
      ];
    }
  }

  if (ERCode.includes("E-021") && attemptCount < 3) {
    if (isReverseOrder)
      setInnerHtml(
        identifierIds.ORDER_STATE,
        "Your return order will be rescheduled",
      );
    else
      setInnerHtml(identifierIds.ORDER_STATE, "Your order will be rescheduled");
  }

  const stepState = checkDeliveryStatus(ERCode);

  if (stepState == stateClasses.FAILED && attemptCount >= 3) {
    if (isReverseOrder) {
      setInnerHtml(identifierIds.ORDER_STATE, "Your return order failed");
    } else setInnerHtml(identifierIds.ORDER_STATE, "Order not delivered");
  }

  initMapOnlyMap([...tempMarker], true);
};
